// extracted by mini-css-extract-plugin
export default {"editConfigInputRow":"EditConfigurationNameModal__editConfigInputRow___RqEGJ"};